import React from "react";
import {FINANCE} from "../../../config/resources";
import {useTranslation} from "react-i18next";


export function FinanceDescriptionCell({value, rowOriginal}){
    const {t} = useTranslation();
    let details = '';
    switch(rowOriginal.type) {
        case FINANCE.TYPE.WITHDRAW:
            details = <small className={`mt-1 `}>
                <div>{t(`form.field.wallet_address`)}: <a href={`https://tronscan.org/#/address/${rowOriginal.data?.wallet}`} className={`hover:text-blue-600 cursor-pointer`} target={"_blank"}>{rowOriginal.data?.wallet}</a></div>
                {rowOriginal.data?.tx_id && <div>{t(`form.field.txid`)}: <a href={`https://tronscan.org/#/transaction/${rowOriginal.data?.tx_id}`} className={`hover:text-blue-600 cursor-pointer`} target={"_blank"}>
                    {`${rowOriginal.data?.tx_id.substr(0,15)}...${rowOriginal.data?.tx_id.substr(-15)}`}
                </a></div>}
            </small>
            break;
        case FINANCE.TYPE.APP_INSTALL:
            details = <small className={`mt-1 `}>
                <div>Click Id: {rowOriginal.data?.udid}</div>
            </small>
            break;
        case FINANCE.TYPE.REFERRAL_BONUS_SUBSCRIPTION:
            details = <small className={`mt-1 `}>
                <div>{t(`form.field.settings_reffprogram.partner_percent`)}: {rowOriginal.data?.referral_percent}%</div>
            </small>
            break;
        case FINANCE.TYPE.REFERRAL_BONUS_INSTALL:
            details = <small className={`mt-1 `}>
                <div>{t(`form.field.settings_reffprogram.partner_percent`)}: {rowOriginal.data?.referral_percent}%</div>
                <div>{t(`form.field.price_install`)}: {rowOriginal.data?.install_price}</div>
                <div>{t(`datatable.column.client_country_code`)}: {rowOriginal.data?.install_geo?.toUpperCase()}</div>
            </small>
            break;
    }

    return (
        <div className={`flex flex-col gap-2`}>
            <div className={`font-light text-grey-500 text-sm`}><small>{t(`widget.latesttopups.order_id`)}: {rowOriginal.order_id}</small></div>
            <div className={`mt-0`}>{value}</div>
            {details}
        </div>
    )
}
